import styled from 'styled-components'

const TimetableFlame = styled.div`
  overflow: auto;
  overflow: scroll;
  margin-top: 18px;
  @media print {
    display: block !important;
    overflow: visible;
  }
  & .react-draggable-dragging {
    cursor: none;
  }
`

export default TimetableFlame
